import { createBrowserHistory } from 'history';

// browser history
export const history = createBrowserHistory();